import React from 'react';
import styled from "@emotion/styled"
import { Button as ButtonBase } from "rebass";

const ButtonElement = styled.a`
  display: inline-block;
`

const Button = (props) => {
  return (
    <ButtonBase as={ButtonElement} {...props}>{props.children}</ButtonBase>
  );
}

export default Button;
